import { type LandingSectionDefinition } from "../../fields";
import { type commonSectionTypes } from "./types";

export const commonSectionDefinitions: Record<(typeof commonSectionTypes)[number], LandingSectionDefinition> = {
  funnelLandingEffects: {
    label: "Śledzenie landingu funnelu (niewidoczne)",
    group: "Funnel",
    fields: [
      {
        key: "stepSlug",
        label: "step_slug w zdarzeniu landing_viewed",
        type: "text",
        placeholder: "landing",
      },
      {
        key: "facebookPixel",
        label: "Piksel Facebooka z ustawień strony",
        type: "boolean",
        help: "Ten sam piksel co na landingach Bikini z kodu.",
      },
    ],
    defaultProps: { stepSlug: "landing", facebookPixel: true },
  },
};
